import React from 'react';
import Card from '../Card/Card';
import Pagination from '../Pagination/Pagination';
import SearchResultStats from '../SearchResultStats/SearchResultStats';

if (process.browser) require('./SearchResultHeader.scss');

export default function SearchResultHeader({
  title,
  currentPage,
  itemsPerPage,
  itemsCount,
  total,
  maxPages,
  query,
}) {
  if (!total) return null;
  const track = { context: 'Search', value: { origin: 'Header' } };

  return (
    <Card className="search-results-header" data-name="search-results-header">
      <h2 data-name="search-result-title">{title}</h2>
      <div className="row">
        <div className="column d-1-2 xs-1-1">
          <SearchResultStats
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            itemsCount={itemsCount}
            total={total}
          />
        </div>
        <div className="column d-1-2 xs-1-1">
          <Pagination
            track={track}
            query={query}
            total={total}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            maxPages={maxPages}
            className="text-right"
          />
        </div>
      </div>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/SearchResultHeader/SearchResultHeader.js